import { toToken } from "~/config/constants/tokens";
import { FarmConfig, SerializedFarmConfig } from "~/config/constants/types";
import { serializeToken } from "~/state/user/hooks/helpers";

export const toSerializeFarmConfig = (chainId: number , farm: FarmConfig) : SerializedFarmConfig => {
    const serializedFarmConfig = {
        ...farm,
        token: farm.token ? serializeToken(toToken(chainId, farm.token)) : undefined,
        quoteToken: farm.quoteToken ?  serializeToken(toToken(chainId, farm.quoteToken)) : undefined,
        dualToken: farm.dualToken ? serializeToken(toToken(chainId, farm.dualToken)) : undefined
      }
    return serializedFarmConfig;
}
